import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    alignItems: 'center',
    gap: spacing.m,
  },
}));
